import {
  materialTransactionsListener,
  setupMaterialTransactionsListeners,
} from './INV/MaterialTransactions/MaterialTransactionsListenerMiddleware';

// المستمعـــــــــات
export const listeners = [materialTransactionsListener];

export const setupListeners = () => {
  setupMaterialTransactionsListeners();
};


export const setupListeners2 = () => {
    setupMaterialTransactionsListeners();
  };
 